export { SearchQuery } from './search-query.model';

export {
  makeQuery,
  setAddress,
  setSearchQuerySort,
  getFacetSet,
  setPresetValues,
} from './search-query-model.utils';
